<script lang="ts" setup>
import { logCompletion } from '@bosca/analytics-client-browser'

const error = ref<string | null>(null)

function doFacebookLogin() {
    signin('facebook')
}

function doGoogleLogin() {
    signin('google')
}

async function signin(type: string) {
    try {
        document.location = '/oauth2/redirect?type=' + type + '&to=https://' + document.location.host;
    }
    catch (e: any) {
        error.value = e.message
        await logCompletion({
            id: 'signin-thirdparty',
            type: 'button',
            content: [],
            extras: {
                error: 'true',
                message: error.value?.toString() || '',
            },
        })
        console.error('signin failed', e)
    }
}
</script>

<template>
  <div class="flex flex-wrap gap-2 justify-between">
    <PButton
      id="login-google"
      class="flex border border-gray-400 bg-white text-black hover:drop-shadow-md w-full rounded-lg p-2 items-center justify-center"
      :click="doGoogleLogin"
    >
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.3055 8.0415H19.5V8H10.5V12H16.1515C15.327 14.3285 13.1115 16 10.5 16C7.1865 16 4.5 13.3135 4.5 10C4.5 6.6865 7.1865 4 10.5 4C12.0295 4 13.421 4.577 14.4805 5.5195L17.309 2.691C15.523 1.0265 13.134 0 10.5 0C4.9775 0 0.5 4.4775 0.5 10C0.5 15.5225 4.9775 20 10.5 20C16.0225 20 20.5 15.5225 20.5 10C20.5 9.3295 20.431 8.675 20.3055 8.0415Z"
          fill="#FFC107"
        />
        <path
          d="M1.6543 5.3455L4.9398 7.755C5.8288 5.554 7.9818 4 10.5013 4C12.0308 4 13.4223 4.577 14.4818 5.5195L17.3103 2.691C15.5243 1.0265 13.1353 0 10.5013 0C6.6603 0 3.3293 2.1685 1.6543 5.3455Z"
          fill="#FF3D00"
        />
        <path
          d="M10.5002 20C13.0832 20 15.4302 19.0115 17.2047 17.404L14.1097 14.785C13.1057 15.5455 11.8577 16 10.5002 16C7.89916 16 5.69066 14.3415 4.85866 12.027L1.59766 14.5395C3.25266 17.778 6.61366 20 10.5002 20Z"
          fill="#4CAF50"
        />
        <path
          d="M20.3055 8.0415H19.5V8H10.5V12H16.1515C15.7555 13.1185 15.036 14.083 14.108 14.7855C14.1085 14.785 14.109 14.785 14.1095 14.7845L17.2045 17.4035C16.9855 17.6025 20.5 15 20.5 10C20.5 9.3295 20.431 8.675 20.3055 8.0415Z"
          fill="#1976D2"
        />
      </svg>
      <span class="ps-3 content-center">{{ $t('getStartedWithGoogle') }}</span>
    </PButton>
    <PButton
      id="login-facebook"
      class="flex border border-gray-400 bg-white text-black hover:drop-shadow-md w-full rounded-lg p-2 items-center justify-center"
      :click="doFacebookLogin"
    >
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.5 10C20.5 4.47656 16.0235 0 10.5 0C4.97656 0 0.5 4.47656 0.5 10C0.5 14.9922 4.15625 19.1289 8.93746 19.8789V12.8906H6.39844V10H8.93746V7.79687C8.93746 5.29102 10.4297 3.90625 12.7148 3.90625C13.8086 3.90625 14.9531 4.10156 14.9531 4.10156V6.5625H13.6914C12.4492 6.5625 12.0625 7.33398 12.0625 8.125V10H14.8359L14.3925 12.8906H12.0625V19.8789C16.8437 19.1289 20.5 14.9922 20.5 10Z"
          fill="#1877F2"
        />
        <path
          d="M14.3925 12.8906L14.8359 10H12.0625V8.125C12.0625 7.33398 12.4492 6.5625 13.6914 6.5625H14.9531V4.10156C14.9531 4.10156 13.8086 3.90625 12.7148 3.90625C10.4297 3.90625 8.93746 5.29101 8.93746 7.79687V10H6.39844V12.8906H8.93746V19.8789C9.44727 19.959 9.96873 20 10.5 20C11.0313 20 11.5527 19.959 12.0625 19.8789V12.8906H14.3925Z"
          fill="white"
        />
      </svg>
      <span class="ps-3 content-center">{{ $t('getStartedWithFacebook') }}</span>
    </PButton>
    <UAlert
        v-if="error"
        class="mt-8"
        color="red"
        variant="solid"
        :title="error"
    />
  </div>
</template>
